module.exports = __webpack_public_path__ + "assets/mention.9fed1f22.svg";